import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
	InfiniteScrollingContentDirective,
	InfiniteScrollingHandlerComponent
} from "../infinite-scrolling-handler/infinite-scrolling-handler.component";
import { InfiniteScrollingListComponent } from "../infinite-scrolling-list/infinite-scrolling-list.component";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { AccountModule } from "@modules/account/account.module";

const components = [
	InfiniteScrollingHandlerComponent,
	InfiniteScrollingListComponent,
	InfiniteScrollingContentDirective
];

@NgModule({
	declarations: [...components],
	imports: [CommonModule, ScrollingModule, AccountModule],
	exports: [...components]
})
export class InfiniteScrollingModule {}
